var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.displayBlock)?_c('Block',{attrs:{"block":_vm.block,"lazy":_vm.lazy}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }